export default __webpack_public_path__ + "static/media/Group 43.d218652d.png";